import React from "react";

const TripHeader = ({ data, status, getStartDate, t }) => {
  return (
    <div className="grid grid-cols-3 border border-slate-200 border-t-0 border-l-0 border-r-0 my-2 pb-1">
      <div className="flex">
        <p className="font-[Gravity] font-bold mr-1">{t("modalDetailTrip.unit_number")}:</p>
      </div>
      <div className="hidden">
        <p className="font-[Gravity] font-bold mr-1">Delivery: </p>
      </div>
      <div className="flex">
        <p className="font-[Gravity] font-bold mr-1">
          {t("modalDetailTrip.start_trip")}
        </p>
        <p className="font-[Gravity]">{getStartDate()}</p>
      </div>
      <div className="flex">
        <p className="font-[Gravity] font-bold mr-1">
          {t("modalDetailTrip.status")}{" "}
        </p>
        <p className={`font-[Gravity] ${status}`}>
          {data?.status === "Pending"
            ? t("monitoringTrips.pending")
            : data?.status === "Refused"
              ? t("monitoringTrips.refused")
              : data?.status === "Complete"
                ? t("monitoringTrips.complete")
                : data?.status === "InProcess"
                  ? t("monitoringTrips.in_process")
                  : data?.status === "Accepted"
                    ? t("monitoringTrips.accept")
                    : ""}
        </p>
      </div>
    </div>
  );
};

export default TripHeader;
